/* Une clé mille routes — thème V8 */
(function () {
  'use strict';
  var U = window.UCMR || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Scène : mise à l'échelle centrée sur le van ---------------- */
  function fitScene(scene) {
    var stage = scene.querySelector('[data-stage]');
    if (!stage) return;
    var W = scene.clientWidth, H = scene.clientHeight;
    if (!W || !H) return;
    var s = Math.max(W / 1440, H / 900);
    var mobile = W < 750;
    var vanX = 530, roadY = 690;                       // centre du van / bas de route dans la scène 1440×900
    var fx = mobile ? 0.5 : vanX / 1440;
    var x = W * fx - vanX * s;
    x = Math.min(0, Math.max(W - 1440 * s, x));
    var reserve = mobile ? 0 : (parseInt(scene.getAttribute('data-reserve'), 10) || 0);
    var bottomMargin = mobile ? 30 : Math.max(60, reserve);
    var y = Math.min(0, H - bottomMargin - roadY * s);
    y = Math.max(H - 900 * s, y);
    stage.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) scale(' + s.toFixed(4) + ')';
  }
  function initScenes(root) {
    var scenes = (root || document).querySelectorAll('[data-scene]');
    scenes.forEach(function (sc) {
      fitScene(sc);
      if ('ResizeObserver' in window) new ResizeObserver(function () { fitScene(sc); }).observe(sc);
      var spd = parseFloat(getComputedStyle(sc).getPropertyValue('--spd')) || 1;
      if (spd !== 1 && sc.getAnimations) {
        try { sc.getAnimations({ subtree: true }).forEach(function (a) { a.playbackRate = spd; }); } catch (e) {}
      }
      // Pause hors écran pour économiser la batterie
      if ('IntersectionObserver' in window && sc.getAnimations) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            try { sc.getAnimations({ subtree: true }).forEach(function (a) { en.isIntersecting && !reduce ? a.play() : a.pause(); }); } catch (e) {}
          });
        }).observe(sc);
      }
    });
  }
  window.addEventListener('resize', function () { document.querySelectorAll('[data-scene]').forEach(fitScene); });

  /* ---------------- Compte à rebours ---------------- */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(target)) return;
      var d = el.querySelector('[data-cd-d]'), h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]');
      function tick() {
        var diff = Math.max(0, target - Date.now());
        var dd = Math.floor(diff / 864e5), hh = Math.floor(diff % 864e5 / 36e5), mm = Math.floor(diff % 36e5 / 6e4);
        if (d) d.textContent = String(dd).padStart(2, '0');
        if (h) h.textContent = String(hh).padStart(2, '0');
        if (m) m.textContent = String(mm).padStart(2, '0');
      }
      tick(); setInterval(tick, 30000);
    });
  }

  /* ---------------- Compteur de pré-inscrits ---------------- */
  function fmt(n) { return n.toLocaleString('fr-FR'); }
  function renderCounter(box, count) {
    var goal = parseInt(box.getAttribute('data-goal'), 10) || 5000;
    var digits = box.querySelectorAll('[data-odo] .u-odo__d');
    var str = String(Math.max(0, count)).padStart(digits.length, '0').slice(-digits.length);
    digits.forEach(function (d, i) { d.textContent = str[i]; });
    box.querySelectorAll('[data-bar]').forEach(function (b) { b.style.width = Math.min(100, count / goal * 100).toFixed(1) + '%'; });
    var steps = [];
    try { steps = JSON.parse(box.getAttribute('data-steps') || '[]'); } catch (e) {}
    var next = steps.find(function (s) { return s.km > count; });
    var nextEl = box.querySelector('[data-next]');
    if (nextEl) {
      nextEl.textContent = count >= goal
        ? 'Objectif atteint : le jeu va bientôt démarrer !'
        : 'Plus que ' + fmt(goal - count) + ' km' + (next ? ' · prochaine étape : ' + fmt(next.km) + ' km · ' + next.label : '');
    }
    box.setAttribute('data-count', count);
  }
  function initCounters(root) {
    (root || document).querySelectorAll('[data-counter]').forEach(function (box) {
      var manual = parseInt(box.getAttribute('data-count'), 10) || 0;
      renderCounter(box, manual);
      var url = box.getAttribute('data-endpoint');
      if (!url) return;
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && typeof j.count === 'number') renderCounter(box, Math.max(j.count, 0)); })
        .catch(function () {});
    });
  }

  /* ---------------- Pré-inscription Klaviyo ---------------- */
  function initSignup(root) {
    (root || document).querySelectorAll('[data-signup]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[type=email]').value.trim();
        var msg = form.querySelector('[data-msg]');
        var btn = form.querySelector('button[type=submit]');
        var company = form.getAttribute('data-company') || (U.klaviyo && U.klaviyo.company);
        var list = form.getAttribute('data-list') || (U.klaviyo && U.klaviyo.list);
        function say(t, ok) { if (msg) { msg.textContent = t; msg.className = 'u-form__msg ' + (ok ? 'is-ok' : 'is-err'); } }
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { say('Vérifie ton adresse e-mail.', false); return; }
        if (!company || !list) { say('Inscription indisponible pour le moment.', false); return; }
        btn && (btn.disabled = true);
        fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: {
            custom_source: form.getAttribute('data-source') || 'Site · page d\'attente',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }, relationships: { list: { data: { type: 'list', id: list } } } } })
        }).then(function (r) {
          if (!r.ok && r.status !== 202) throw new Error(r.status);
          var box = document.querySelector('[data-counter]');
          var n = box ? (parseInt(box.getAttribute('data-count'), 10) || 0) + 1 : null;
          if (box) renderCounter(box, n);
          say(n ? 'C\'est noté ! Tu es le km ' + fmt(n) + '.' : 'C\'est noté, à très vite !', true);
          form.querySelector('input[type=email]').value = '';
          document.querySelectorAll('[data-scene]').forEach(function (sc) {
            sc.classList.remove('is-boost'); void sc.offsetWidth; sc.classList.add('is-boost');
            if (sc.getAnimations) try { sc.getAnimations({ subtree: true }).forEach(function (a) { var pr = a.playbackRate; a.playbackRate = pr * 2.5; setTimeout(function () { a.playbackRate = pr; }, 1400); }); } catch (e) {}
          });
        }).catch(function () { say('Oups, ça n\'a pas marché. Réessaie dans un instant.', false); })
          .finally(function () { btn && (btn.disabled = false); });
      });
    });
  }

  /* ---------------- Panier (tiroir) ---------------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  function openCart() {
    if (!drawer) { window.location.href = '/cart'; return; }
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    overlay && (overlay.hidden = false); document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    overlay && (overlay.hidden = true); document.documentElement.style.overflow = '';
  }
  function refreshCart(open) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-drawer'];
        if (drawer && html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var sec = drawer.querySelector('.shopify-section') || drawer;
          var inner = tmp.querySelector('.shopify-section') || tmp;
          sec.innerHTML = inner.innerHTML;
          var c = drawer.querySelector('[data-cd-count]');
          if (c) document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.getAttribute('data-cd-count'); });
        }
        if (open) openCart();
      });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add]');
    if (!form || !drawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'); var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
    fetch((U.routes && U.routes.cart_add) || '/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(true); })
      .catch(function (err) { alertInline(form, (err && err.description) || 'Impossible d\'ajouter ce produit.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });
  function alertInline(form, text) {
    var p = form.querySelector('[data-err]');
    if (!p) { p = document.createElement('p'); p.setAttribute('data-err', ''); p.className = 'u-form__msg is-err'; form.appendChild(p); }
    p.textContent = text;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { if (drawer) { e.preventDefault(); openCart(); } return; }
    if (e.target.closest('[data-close-cart]') || e.target === overlay) { closeCart(); return; }
    var q = e.target.closest('[data-qty]');
    if (q) {
      e.preventDefault();
      fetch((U.routes && U.routes.cart_change) || '/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: q.getAttribute('data-key'), quantity: parseInt(q.getAttribute('data-qty'), 10) })
      }).then(function () { return refreshCart(false); });
      return;
    }
    var burger = e.target.closest('[data-burger]');
    if (burger) {
      var nav = document.querySelector('[data-mnav]');
      if (nav) { var open = nav.classList.toggle('is-open'); burger.setAttribute('aria-expanded', open); }
      return;
    }
    // Ancres « Voir le lot » etc. : défilement doux
    var a = e.target.closest('a[href^="#"]');
    if (a && a.getAttribute('href').length > 1) {
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function init(root) { initScenes(root); initCountdowns(root); initCounters(root); initSignup(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  // Éditeur de thème : réinitialiser une section rechargée
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
